import {
  SETTING_EMAIL_PAGE_REQUEST,
  SETTING_EMAIL_SUBMIT_FORM,
  SETTING_EMAIL_SHOW_RECIPIENT_MODAL,
  SETTING_EMAIL_HIDE_RECIPIENT_MODAL,
  SETTING_EMAIL_ON_CANCEL_MANAGE_RECIPIENTS,
  SETTING_EMAIL_ON_CONFIRM_MANAGE_RECIPIENTS,
  SETTING_EMAIL_ON_CLICK_MANAGE_RECIPIENTS,
  SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM,
  SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS,
  SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS,
  SETTING_EMAIL_ON_CLICK_DELETE_ICON,
  SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL,
  SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL,
  SETTING_EMAIL_CANCEL_DELETE_RECIPIENT,
  SETTING_EMAIL_DELETE_RECIPIENT,
  SETTING_EMAIL_SET_DELETED_RECIPIENT,
  SETTING_EMAIL_SET_BUSINESS_SETTINGS,
} from './constants';

export function pageRequest() {
  return {
    type: SETTING_EMAIL_PAGE_REQUEST,
    payload: {},
  };
}

export function submitForm(data) {
  return {
    type: SETTING_EMAIL_SUBMIT_FORM,
    payload: { data },
  };
}

export function setBusinessSettings(settings) {
  return { type: SETTING_EMAIL_SET_BUSINESS_SETTINGS, payload: { settings } };
}

export function showRecipientModal() {
  return { type: SETTING_EMAIL_SHOW_RECIPIENT_MODAL, payload: {} };
}

export function hideRecipientModal() {
  return { type: SETTING_EMAIL_HIDE_RECIPIENT_MODAL, payload: {} };
}

export function setPreviousEmailNotificationForm(
  previousEmailNotificationForm
) {
  return {
    type: SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM,
    payload: { previousEmailNotificationForm },
  };
}

export function onCancelManageRecipients(previousEmailNotificationForm) {
  return {
    type: SETTING_EMAIL_ON_CANCEL_MANAGE_RECIPIENTS,
    payload: { previousEmailNotificationForm },
  };
}

export function onConfirmManageRecipients(
  emailNotificationForm,
  previousEmailNotificationForm
) {
  return {
    type: SETTING_EMAIL_ON_CONFIRM_MANAGE_RECIPIENTS,
    payload: { emailNotificationForm, previousEmailNotificationForm },
  };
}

export function onClickManageRecipients(previousEmailNotificationForm) {
  return {
    type: SETTING_EMAIL_ON_CLICK_MANAGE_RECIPIENTS,
    payload: { previousEmailNotificationForm },
  };
}

export function showSettingAlertRecipientsErrors() {
  return {
    type: SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS,
    payload: {},
  };
}

export function hideSettingAlertRecipientsErrors() {
  return {
    type: SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS,
    payload: {},
  };
}

export function onClickDelete(deletedRecipient) {
  return {
    type: SETTING_EMAIL_ON_CLICK_DELETE_ICON,
    payload: { deletedRecipient },
  };
}

export function showDeleteRecipientModal() {
  return { type: SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL, payload: {} };
}

export function hideDeleteRecipientModal() {
  return { type: SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL, payload: {} };
}

export function cancelDeleteRecipient(deletedRecipient?) {
  return {
    type: SETTING_EMAIL_CANCEL_DELETE_RECIPIENT,
    payload: { deletedRecipient },
  };
}

export function onDeleteRecipient(deletedRecipient, emailNotificationForm) {
  return {
    type: SETTING_EMAIL_DELETE_RECIPIENT,
    payload: { deletedRecipient, emailNotificationForm },
  };
}

export function setDeletedRecipient(deletedRecipient) {
  return {
    type: SETTING_EMAIL_SET_DELETED_RECIPIENT,
    payload: { deletedRecipient },
  };
}
